import React, { PureComponent } from "react";
import styled from "styled-components";
import LinkedImage from "@fdmg/ts-react-linked-image";

export interface Props {
  isCustomPlaylist?: boolean;
  sponsorsLength: number;
  sponsors: any;
}
/**
 * Sponsored Ad component - Only renders if there are sponsors added to the
 * program. If there is a sponsor text the colofon will be rendered and
 * if there is an image this will be rendered as well.
 */
export default class Sponsor extends PureComponent<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    if (this.props.sponsors && this.props.sponsors.length) {
      const colofon = (
        <Colofon>
          <span>
            Deze podcast wordt u aangeboden door:{" "}
            {this.props.sponsors.map((sponsor, index) => {
              const newIndex = index + 1;
              return (
                <span key={index}>
                  <a href={sponsor.websiteUrl} target="_blank">
                    {sponsor.name}
                  </a>
                  {this.props.sponsors.length > 1 &&
                  this.props.sponsors.length !== newIndex
                    ? newIndex === this.props.sponsors.length - 1
                      ? " en"
                      : ","
                    : ""}
                </span>
              );
            })}
          </span>
        </Colofon>
      );

      const sponsor = (
        <SponsorImage>
          {this.props.sponsors.map((sponsor, index) => (
            <LinkedImage
              alt={sponsor.name}
              href={sponsor.websiteUrl}
              src={sponsor.logoUrl}
              target="_blank"
              key={index}
            />
          ))}
        </SponsorImage>
      );

      return (
        this.props.sponsorsLength && (
          <SponsorFooter>
            {colofon}
            {sponsor}
          </SponsorFooter>
        )
      );
    } else {
      return null;
    }
  }
}

const SponsorImage = styled.div`
  img {
    width: auto;
    height: 30px;
    margin-right: 5px;
  }
`;

const Colofon = styled.span`
  margin: 5px 0;
  > span {
    display: block;
    width: 100%;
    > span {
      margin-right: 3px;
      a {
        margin-right: 0;
      }
    }
  }
`;

const SponsorFooter: any = styled.footer`
  display: -ms-flexbox;
  display: flex;
  justify-content: space-evenly;
  line-height: 1.4;
  padding: 5px;
  color: #1f1f1f;
  font-size: 11px;
  -ms-flex-direction: column;
  flex-direction: column;
  background-color: transparent;
`;
